import { EventListenerFocusTrapInertStrategy } from '@angular/cdk/a11y';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Global } from 'src/app/Service/global.service';
import { MvmNaviresService } from 'src/app/Service/mvm-navires.service';

@Component({
  selector: 'app-smart-gate',
  templateUrl: './smart-gate.component.html',
  styleUrls: ['./smart-gate.component.scss']
})
export class SmartGateComponent implements OnInit {

  constructor(public global: Global, private service: MvmNaviresService, private route: ActivatedRoute) { }

  serv = '00';
  preavis;
  preavisetat = "";
  Rdvs;
  res = { Title: "", Msg: "", data: null, url: null };
  ngOnInit(): void {
    this.global.CurentLanguage.pipe(takeUntil(this.global.navigationEnd)).subscribe(lg => {
      if (lg.code === 'fr') {
        this.route.params.subscribe(param => {
          if (param["service"] !== null && param["service"] !== undefined && (param["service"].toLowerCase() === "p" || param["service"].toLowerCase() === "r" || param["service"].toLowerCase() === "g")) {
            this.serv = param["service"].toLowerCase();
          } else {
            this.serv = "00"
          }
          setTimeout(() => {
            let nbrc = "";
            if (param["nbrC"]) {
              //@ts-ignore
              param["nbrC"] !== null && param["nbrC"] !== undefined ? nbrc = document.getElementById("nmconteneur").value = param["nbrC"] : nbrc = ""
            }
            //@ts-ignore
            this.serv == "r" && (param["nmRdv"] !== null && param["nmRdv"] !== undefined) ? document.getElementById("nmRdv").value = param["nmRdv"] : null
            if (this.serv !== '00') {
              this.lancer(nbrc);
            }
          }, 600);

        })
      } else {
        this.global.setCurentLanguge('fr');
      }

    });
  }


  lancer(nbrC) {
    this.preavis = null;
    this.Rdvs = null;
    if (this.serv == "p" && nbrC != "") {
      this.service.getPreavisByNbr(nbrC).subscribe(data => {
        if (data["Conteneur"] != null) {
          this.preavis = data["Conteneur"];
          this.preavisetat = "le conteneur est programmé";
        } else {
          this.service.getPreavisByNbrall(nbrC).subscribe(data => {
            if (data["Conteneur"] != null) {
              this.preavis = data["Conteneur"];
              this.preavisetat = "le Conteneur déjà au port";
            } else {
              this.preavis = '-1';
              this.preavisetat = "Aucun conteneur trouvé avec ce numéro";
            }
          })
        }
      })
    }
    if (this.serv == "r" && nbrC != "") {
      this.service.getRdvByNbrC(nbrC).subscribe(data => {
        this.Rdvs = data;
      })
      //@ts-ignore
    } else if (nbrC == "" && document.getElementById("nmRdv") !== null && document.getElementById("nmRdv").value != "") {
      //@ts-ignore
      this.service.getRdvByNbrR(document.getElementById("nmRdv").value).subscribe(data => {
        this.Rdvs = data;
      })

    }
    if (this.serv == "g" && nbrC != "") {
      this.service.getGestionAccessPortSOA(nbrC).subscribe(data => {
        if (data["numAutorisation"] == null) {
          this.res.Title = "Autorisation non valide";
          this.res.Msg = "Aucune autorisation trouvée avec ce numero : " + nbrC;
          this.res.data = null;
        }
        else {
          //en attente de verifier avec la date => nouvelle versin Portnet
          if (data["typeAcces"].toLowerCase() == "permanent") {
            if (data["etatBadge"].toLowerCase() == "s") {
              this.res.Title = "Autorisation suspendue";
              this.res.Msg = "le badge est suspendu, Pour plus d'info, merci de contacter la capitainerie";
              this.res.data = null;
            }
            else {
              this.StartActivity(data,nbrC);
            }
          }
          else {
            if (data["dateValidation"] == null) {

              let dateDebut = data["dateDebut"].split('-')[2] + "/" + data["dateDebut"].split('-')[1] + "/" + data["dateDebut"].split('-')[0]
              let dateFin = data["dateFin"].split('-')[2] + "/" + data["dateFin"].split('-')[1] + "/" + data["dateFin"].split('-')[0]
              let debut = new Date(dateDebut);
              let fin = new Date(dateFin);
              let now = new Date();

              if (now < debut) {
                this.res.Title = "Autorisation non valide";
                this.res.Msg = "Vous êtes en avance votre autorisation prend effet le   : " + debut.toLocaleDateString();
                this.res.data = null;
              }
              else if (now > fin) {
                this.res.Title = "Autorisation non valide";
                this.res.Msg = "Vous êtes en retard votre autorisation a pris fin le  : " + fin.toLocaleDateString();
                this.res.data = null;
              }
              else {
                this.StartActivity(data,nbrC);
              }
            }
            else {
              if (data["etatBadge"].toLowerCase() == "s") {
                this.res.Title = "Autorisation suspendue";
                this.res.Msg = "le badge est suspendu, Pour plus d'info, merci de contacter la capitainerie";
                this.res.data = null;
              }
              else {
                this.StartActivity(data,nbrC);
              }
            }

          }
        }
      })
    }
  }

  StartActivity(data, cin) {
    this.service.getDocbyCIN(cin).subscribe(result => {
      this.res.Title = "Autorisation valide";
      this.res.Msg = "";
      this.res.data = data;
      this.res.url=result["fileContentByte"];
    })
  }
  getPort(code) {
    switch (code) {
      case "01":
        return "Casablanca";
      case "02":
        return "Agadir";
      case "03":
        return "Jorf Lasfar";
      default:
        return code
    }

  }

  convertDate(d) {
    return d.split("T")[0];
  }
}
